<script>
  import {
    page,
  } from '@inertiajs/svelte'

  let body = $page.props.Templates.faq
</script>
{@html body}
